/**
 * Hydration-Helfer für das react-snap-Prerendering.
 *
 * react-snap prerendert nur die in `reactSnap.include` (package.json) gelisteten
 * Routen. Wird eine NICHT prerenderte Route (z. B. /messages) direkt aufgerufen
 * oder neu geladen, liefert der SPA-Fallback (nginx `try_files … /index.html`)
 * das prerenderte STARTSEITEN-HTML aus. `#root` hat dann zwar Kindknoten,
 * diese gehören aber zu einer anderen Route.
 *
 * Würde man dieses Markup mit `hydrateRoot` gegen die tatsächliche Route
 * hydrieren, schlägt die Hydration fehl: React verwirft das Markup und rendert
 * den gesamten Root neu (Minified React error #423) und meldet den Fehler über
 * das Browser-`reportError` an `window.onerror`.
 *
 * Damit wir das vermeiden, stempelt react-snap via `window.snapSaveState` den
 * prerenderten Pfad als `window.__PRERENDERED_PATH__` in die HTML. Zur Laufzeit
 * hydrieren wir nur, wenn dieser Pfad zur aktuellen Route passt.
 */

/** Pfad normalisieren (Trailing-Slashes entfernen, leerer Pfad → "/"). */
export const normalizePath = (path) => (path || '/').replace(/\/+$/, '') || '/';

/**
 * Entscheidet, ob das ausgelieferte Markup hydriert werden darf.
 *
 * @param {Object}  args
 * @param {boolean} args.hasChildNodes    Hat #root bereits Kindknoten?
 * @param {string=} args.prerenderedPath  Von react-snap gestempelter Pfad (window.__PRERENDERED_PATH__).
 * @param {string}  args.currentPath      Aktueller window.location.pathname.
 * @returns {boolean} true → hydrateRoot, false → createRoot.
 */
export const shouldHydrate = ({ hasChildNodes, prerenderedPath, currentPath }) => {
  if (!hasChildNodes) return false;
  if (typeof prerenderedPath !== 'string') return false;
  return normalizePath(prerenderedPath) === normalizePath(currentPath);
};
